import { css } from 'styled-components';
import { media, rem } from '../../../helpers/mixins';
import { GRAY_TEXT, LABEL_COLOR, GRAY, PURPLE_LIGHT, PINK } from '../../../constants/colors';

export default {
  mainWrapper: css`
    // margin: 20px;
    ${media.md`
      // margin: 40px;
    `};
  `,
  destinationWrapper: css`
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    width: auto;
    height: auto;
    ${media.md`
      display: flex;
      justify-content: center;
      flex-direction: row;
      min-width: 975px;
    `};
  `,
  parkingWrapper: css`
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    width: auto;
    height: auto;

    ${media.switchHeaderToDesktop`
      padding: 20px 0px 0px;
    `};

    ${media.md`
      display: flex;
      justify-content: center;
      flex-direction: row;
      // padding: 20px 80px 0px;
    `};
  `,
  addPlacesContainer: css`
    display: block;
    width: min-content;
    ${media.mn1`
      margin-top: 10px;
    `};
    ${media.md`
      margin-top: 0px;
    `};
`,
  rounderComponent: css`
  display: flex;
  justify-content: space-around;
`,

increment: css`
  width: 30px;
  height: 30px;
  border-radius: 30px;
  background-color: white;
  border: 2px;
  border-color: gray;
  justify-content: center;
  border-width: 1.5px;
  border-style: solid;
  border-color: gray;
  display: flex;
  color: pink;
  font-weight: bolder;
  cursor: pointer;
`,
  personalInfoWrapper: css`
    flex: 1;
    padding: 16px 16px 16px;

    ${media.sm`
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    `};
  `,
  column: css`
    ${media.md`
      display: flex;
      flex-direction: column;
      margin: auto;
    `};
  `,
  rowOriginDestination: css`
    display: grid;
    grid-template-columns: repeat(3, minmax(10px, 1fr));
    ${media.md`
      display: flex;
      width: 100%;
      flex-direction: row;
      justify-content: space-around;
      margin: auto;
    `};
  `,
  row: css`
    display: grid;
    grid-template-columns: repeat(2, minmax(10px, 1fr));
    ${media.md`
      display: flex;
      width: 100%;
      flex-direction: row;
      justify-content: space-around;
      margin: auto;
    `};
  `,
  placeWrapper: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-self: center;
    height: auto;
    width: 120px;
    padding: 20px 8px 20px;
    border-radius: 16px;
    margin-bottom: 5px;
    border-width: 2px;
    border-style: solid;
    ${media.md`
      width: 130px;
    `};

  `,
  placeCode: css`
    font-size: 16px;
    margin-inline: auto;
    ${media.md`
      font-size: 20px;
    `};
  `,
  placeStr: css`
    font-size: 10px;
    ${media.md`
    font-size: 13px;
  `};
    margin-inline: auto;
  `,
  placeLabel: ({ color }) => css`
    color: ${color || GRAY_TEXT};
    font-size: ${rem('10px')};
    width: 95%;
    align-self: end;
  `,
  togglePlaces: css`
    width: 30px;
    height: 30px;
    display: flex;
    align-self: center;
    justify-self: center;
    margin-bottom: 20px;
  `,

  shuttleIcon : css`
    width: auto;
    height: 25px;
    display: flex;
    align-self: center;
    justify-self: center;
    margin-top: 15px;
    ${media.mn1`
      display:none;
    `}
    ${media.sm`
    display: flex;
    `}
  `,
  inputRounderSelect: ({
    type, width, padding, hasBlackTheme, value, isSorting, textColor
  }) => css`
  border-radius: 0.25rem;
  border-bottom: 1px solid ${GRAY_TEXT};
  font-weight: bolder;
  color: #726C79;
  font-size: 1rem;
  padding-inline: 5px 0;
  width: ${width || '100%'};
  height: 38px;
  margin-left ${padding || 0};
  border: ${isSorting ? 'none' : `1px solid ${hasBlackTheme ? '#ccc' : GRAY_TEXT}`};
  background-color: white;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  overflow: hidden;
  background: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+) no-repeat 95% 50%;

  ${value === '' && hasBlackTheme && css`
    color: #757575;
  `}

  ${isSorting && css`
    border: none;
  `}
  border-color: ${!!(value) ? '#28A745' : PINK};

  ${type === 'date' && !textColor && css`
    &::-webkit-calendar-picker-indicator {
      filter: invert(1);
    }
  `}
  option {
    color: black;
    font-size: ${rem('16px')};
  }
`,
  labelInput: ({ color }) => css`
    color: ${color || GRAY_TEXT};
    font-size: ${rem('10px')};
    margin-top: 4px;
    margin-bottom: 5px;
  `,
  labelTop: css`
    font: 16px Arial, sans-serif;
    line-height: 1.5;
    color: #000000;
    margin-bottom: 0.5rem;
  `,
  inputsWrapper: css`
    display: flex;
    flex-direction: column;
    width: 95%;
    margin-top: 10px;
    // justify-self: center;
    ${media.md`
      margin-top: 0;
      margin-inline: 10px;
      width: auto;
      margin-bottom: 5px
  `}
  `,


  input: ({ type, hasBlackTheme, value, isSorting, textColor }) => css`
  position: relative;
  color: ${hasBlackTheme || isSorting ? LABEL_COLOR : GRAY_TEXT};
  ${textColor && css`
      color: ${textColor};
  `}
  width: 100%;
  font-size: ${isSorting ? rem('12px') : rem('16px')};
  border: none;
  box-shadow: none;
  border-radius: 12px;
  padding: 0.25em;
  background-color: transparent;
  background-image: none;
  appearance: none;
  outline: none;
  font-weight: bolder;
  border: ${isSorting ? 'none' : `1px solid ${hasBlackTheme ? '#ccc' : GRAY_TEXT}`};

  &:focus {
    border: ${isSorting ? 'none' : `1px solid ${hasBlackTheme ? LABEL_COLOR : GRAY_TEXT}`};
  }

  ${value === '' && hasBlackTheme && css`
    color: #757575;
  `}

  ${isSorting && css`
    border: none;
  `}

  ${type === 'date' && !textColor && css`
    &::-webkit-calendar-picker-indicator {
    }
  `}
  option {
    color: black;
    font-size: ${rem('16px')};
  }
`,

  divCalendar: ({ width, hasBlackTheme, isSorting }) => css`
  border-radius: 10px;
  border-bottom: 1px solid ${GRAY_TEXT};
  font-weight: 900;
  color: #292033;
  padding-inline: 10px 0;
  width: ${width || '90px'};
  border: ${isSorting ? 'none' : `1px solid ${hasBlackTheme ? '#ccc' : GRAY_TEXT}`};
`,
  subtitle: css`
    font-size: 15px;
    padding: 10px 0px 10px;
  `,

  info: ({
    isTotal, maxWidth, textAlign, isSavingMoney
  }) => css`
    font-size: ${rem(isTotal ? '24px' : '16px')};
    color: ${PURPLE_LIGHT};
    margin-bottom: 16px;
    text-align: ${textAlign || 'left'};

    ${isTotal && css`
      flex: 1;
      margin-left: 8px;
      justify-self: flex-start;
      margin-bottom: 0;
      line-height: ${rem('32px')};
      margin-right: 24px;

      ${media.sm`
        font-size: ${rem(isSavingMoney ? '13px' : '20px')};
      `}

      ${media.md`
        font-size: ${rem(isSavingMoney ? '20px' : '24px')};
      `}
    `}

    ${maxWidth && css`
      max-width: 85%;
      margin-top: 8px;

      ${media.sm`
        max-width: ${maxWidth};
      `}
    `}

    span {
      text-decoration: line-through;
      color: ${GRAY};
    }

  `,


};
